<template lang="pug">
section.hero.is-small
  .hero-body
    .container
      h1.title {{ this.title }}
      h2.subtitle {{ this.subtitle }}
</template>

<script>
export default {
  name: "Hero",

  props: ["title", "subtitle"]
};
</script>
